import { IPagination } from "./api";
export interface IResponseListSLAs extends IPagination {
  slas: ISLA[];
}

export enum SLAMode {
  ABSOLUTE_DATE = 'absolute_date',    // compara diretamente com um campo de data existente
  RELATIVE = 'relative',              // calcula prazo com base em um campo + tempo
  MANUAL_DEADLINE = 'manual_deadline' // o prazo é definido manualmente pelo usuário (sem campo base)
}

export enum SLAStartField {
  PLANNED_DATE = 'plannedDate',
  DEADLINE_DATE = 'deadlineDate',
  CREATED = 'createdIn',
  STARTED = 'startDate',
}

export interface IResponseShowSLA {
  sla: ISLA;
}
export interface ISLA {
  id?: number;
  name: string;
  webhookUrl: string;
  mode: SLAMode;
  timeLimitInHours?: number;
  baseField?: SLAStartField;
  notifications: any[];
  isActive: boolean;
  createdIn?: Date;
  updatedIn?: Date;
}